import React, { useEffect, useRef } from 'react';
import * as dc from 'dc';
import $ from 'jquery';
import D3ChartService from './d3ChartService';

interface PieChartProps {
  reportData: {
    series: any[];
    categories: string[];
  };
  radius: number;
  height: number;
  includeLegend: boolean;
}

const PieChart: React.FC<PieChartProps> = ({ reportData, radius, height, includeLegend }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const {
    addTooltips,
    adjustLegend,
    watchResizeEvents,
    resizeChart,
    buildChartData,
    percent,
  } = D3ChartService;

  useEffect(() => {
    if (reportData && chartRef.current) {
      const chartData = buildChartData(reportData.series, reportData.categories);
      const chart = dc.pieChart(chartRef.current);

      chart
        .radius(radius)
        .width($(chartRef.current).width() || 0)
        .height(height)
        .dimension(chartData.dimension)
        .group(chartData.group, chartData.stackNames[0])
        .valueAccessor((d: any) => d.value.values[0])
        .label((d: any) => d.key)
        .title((d: any) => {
          const percentage = percent(d.value.values[0], chartData.valuesTotal);
          return `${d.key}: ${percentage}%`;
        })
        .minAngleForLabel(0.5)
        .emptyTitle('No Data')
        .transitionDuration(0); // Disable initial transition

      if (includeLegend) {
        chart.legend(dc.legend().x(5).y(height - reportData.categories.length*16));
        chart.on('renderlet', adjustLegend);
      }

      const resizeWatch = chartRef.current ? watchResizeEvents(chart, chartRef.current, resizeChart) : null;
      chart.on('renderlet', addTooltips);

      chart.render();

      // Enable transitions after the initial render
      chart.transitionDuration(750);

      return () => {
        if (resizeWatch) {
          resizeWatch();
        }
      };
    }
  }, [reportData, radius, height, includeLegend, buildChartData, adjustLegend, watchResizeEvents, resizeChart, addTooltips, percent]);

  return <div ref={chartRef} id="pie-chart"></div>;
};

export default PieChart;